import { createFeatureSelector, createSelector } from "@ngrx/store";
import {  languageFeatureKey, LanguageState } from "./language.reducer";

export const getLanguageState = createFeatureSelector<LanguageState>(languageFeatureKey);
export const getLanguageList = createSelector(getLanguageState, (state) => state.languageList);
export const getLangToShow = createSelector(getLanguageState, (state) => state.langToShow);
